import { useCallback } from 'react';
import { useCreateEmissorOrderMutation, } from '../services/contractOrdersApi';
export function useEmissorCreateOrder() {
    const [trigger, state] = useCreateEmissorOrderMutation();
    const createOrder = useCallback(({ contractId, body }) => trigger({ contractId, body }).unwrap(), [trigger]);
    return { createOrder, isLoading: state.isLoading, isError: state.isError };
}
